import { stringifyQs } from "@dashboard/utils/urls";
import { parse as parseQs } from "qs";
import urlJoin from "url-join";

export const wsmComposeSectionUrlName = "/wsm/compose";

// Option sets
export const wsmOptionSetListPath = urlJoin(wsmComposeSectionUrlName, "option-sets") + "/";
export const wsmOptionSetAddPath = urlJoin(wsmOptionSetListPath, "add");
export const wsmOptionSetPath = (id: string) => urlJoin(wsmOptionSetListPath, id);
export const wsmOptionSetUrl = (id: string) => wsmOptionSetPath(encodeURIComponent(id));

// Fees
export const wsmFeeListPath = urlJoin(wsmComposeSectionUrlName, "fees") + "/";
export const wsmFeeAddPath = urlJoin(wsmFeeListPath, "add");
export const wsmFeePath = (id: string) => urlJoin(wsmFeeListPath, id);
export const wsmFeeUrl = (id: string) => wsmFeePath(encodeURIComponent(id));

// Compliance: one row per product, so the detail path carries a PRODUCT id.
export const wsmComplianceListPath = urlJoin(wsmComposeSectionUrlName, "compliance") + "/";
export const wsmCompliancePath = (productId: string) =>
  urlJoin(wsmComplianceListPath, productId);
export const wsmComplianceUrl = (productId: string) =>
  wsmCompliancePath(encodeURIComponent(productId));

/**
 * A create screen opened FROM a product arrives with that product already
 * picked. The id is the truth; the name rides along only so the picker can show
 * a label before its own search has come back.
 */
export interface WsmProductPrefill {
  id: string;
  name?: string | null;
}

const withProduct = (path: string, prefill?: WsmProductPrefill | null) =>
  prefill?.id
    ? `${path}?${stringifyQs({
        product: prefill.id,
        ...(prefill.name ? { productName: prefill.name } : {}),
      })}`
    : path;

export const wsmOptionSetAddUrl = (prefill?: WsmProductPrefill | null) =>
  withProduct(wsmOptionSetAddPath, prefill);
export const wsmFeeAddUrl = (prefill?: WsmProductPrefill | null) =>
  withProduct(wsmFeeAddPath, prefill);

/** The other half of withProduct: what a create screen reads on the way in. */
export const readWsmProductPrefill = (search: string): WsmProductPrefill | null => {
  const params = parseQs(search.replace(/^\?/, ""));
  const id = typeof params.product === "string" ? params.product : "";
  const name = typeof params.productName === "string" ? params.productName : "";

  return id ? { id, name } : null;
};
